<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="password-recovery">
            <div class="password-recovery-items-area">

                <h2 class="password-recovery-items-area__title margin-bottom-10">{{'EMAIL_ADDRESS' | translate}}</h2>
                <p class="required-text">{{'REQUIRED_FIELDS_FORM_TITLE' | translate}}</p>

                <form ridangoFocusInvalidInput [formGroup]="_emailForm" (ngSubmit)="submitForm()">
                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field class="form-margin-10">
                            <input ridangoInput [formControl]="_emailForm.controls.email" name="email" type="email"
                                required />
                            <ridango-label>{{'PH_EMAIL' | translate}}</ridango-label>
                            <ridango-error
                                *ngIf="_emailForm.controls.email.hasError('email') && !_emailForm.controls.email.hasError('required')">
                                {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                            </ridango-error>
                            <ridango-error
                                *ngIf="_emailForm.controls.email.touched && _emailForm.controls.email.hasError('required')">
                                {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__footer">
                        <div class="edit-profile-account-items-area__right">
                            <button class="btn btn--maximal btn--primary btn--big">{{'BUTTON_NEXT' |
                                translate}}</button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>
